var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 336,
    viewBox: "0 0 512 336",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.172 335.724H8.828A8.829 8.829 0 0 1 0 326.896V9.103A8.829 8.829 0 0 1 8.828.275h494.345a8.829 8.829 0 0 1 8.828 8.828v317.793a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.828.276c-2.387 0-4.535.967-6.124 2.506l359.228 332.942h26.483L26.483.276H8.828zm141.241 0h-26.483l361.931 335.448h17.655c2.387 0 4.535-.967 6.124-2.506L150.069.276z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464655",
    d: "M26.483.276l361.931 335.448h97.103L123.586.276z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTt);
export default __webpack_public_path__ + "static/media/tt.a27db96aed9a0377f3fd1d6c6cb53aa8.svg";
export { ForwardRef as ReactComponent };